import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/hostname";
import url from "../url";
import { CashbackResponseInner } from "../types/Cashback";

type CashbackResponse = {
  cashbackDaily: CashbackResponseInner;
  cashbackWeekly: CashbackResponseInner;
  cashbackMonthly: CashbackResponseInner;
};

const request = () =>
  api(true, true).get<CashbackResponse>(
    url.config.api.loyalty.loyaltyCashbackValueInfo,
  );

export const useGetCashbackInfo = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["user cashbacks"],
    queryFn: request,
    refetchOnWindowFocus: false,
  });

  return {
    cashbackDaily: data?.data?.cashbackDaily,
    cashbackWeekly: data?.data?.cashbackWeekly,
    cashbackMonthly: data?.data?.cashbackMonthly,
    isLoadingCashback: isLoading,
  };
};
